import {AxiosRequestConfig} from "axios";
import i18n from "i18next";


const NORMAL_CONTENT_TYPE_ENDPOINTS = ['/add-cart-item'] // add normal endpoint here guys

export default async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {

    const lang = i18n.language
    let countryCode = localStorage.getItem('countryCode')
    if (countryCode == null || countryCode==undefined)
        countryCode = 'jo'


    const url = config.url ?? "";

    const shouldKeepDefaultContentType = NORMAL_CONTENT_TYPE_ENDPOINTS.some(
        endpoint => url.includes(endpoint)
    );

    if (!shouldKeepDefaultContentType) {
        config.headers = {
            ...config.headers,
            "Content-Type": "application/x-www-form-urlencoded",
        };
    }

    config.headers['source'] = 'desktop'
    config.headers['country'] = countryCode
    config.headers['enforce-language'] = lang

    config.params = {
        ...config.params,
    }

    return config
}